import JustValidate from 'just-validate';
import Inputmask from "inputmask";
// import { number } from '../components/itl.js';
// console.log(number);

// const button = document.querySelector('.form__submit-btn');

export const validateForms = (selector, ruless, afterSend) => {
  const rules = structuredClone(ruless);
  // const form = document?.querySelector(selector);
  const form = selector;
  // console.log(form)
  const telSelector = form?.querySelector('input[type="tel"]');
  // const telSelector = this.querySelector('input[type="tel"]');
  // console.log(telSelector)

  if (!form) {
    console.error('Нет такого селектора!');
    return false;
  }

  if (!rules) {
    console.error('Вы не передали правила валидации!');
    return false;
  }

  if (telSelector) {
    // const inputMask = new Inputmask('(506) 234 9999',{ "placeholder": "X" });
    // inputMask.mask(telSelector);
    // console.log(inputMask)

    for (let item of rules) {
      // console.log(rules)
      // debugger
      if (item.tel) {
      // if (item.tel && !item.rules[2]) {
        item.rules.push({
          rule: 'function',
          validator: function() {
            // const phone = telSelector.inputmask.unmaskedvalue();
            const phone = telSelector.value;
            let phoneNumbers = phone.replace('+', '');
            // let number = phone.length;
            console.log(telSelector.value)
            console.log(phoneNumbers)
            // console.log(number);
            return phoneNumbers.length === 11;
            // console.log(typeof (phone));

            // return number.length === 11;
            // console.log(number.length)
          },
          errorMessage: item.telError
        });
      }
      // console.log(item);
    }
  }

  const validation = new JustValidate(selector);
  // const validation = new JustValidate(form);

  for (let item of rules) {
    validation
      .addField(item.ruleSelector, item.rules);
  }

  validation.onSuccess((ev) => {
    // console.log(ev.target)
    let formData = new FormData(ev.target);

    let xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          if (afterSend) {
            afterSend();
          }
          console.log('Отправлено');
        }
        else {
          console.log('не отправлено');
          form.querySelector('.form-message-wrong').classList.add('show')
        }
      }
    }

    xhr.open('POST', 'mail.php', true);
    xhr.send(formData);

    ev.target.reset();
  })

  validation.onFail((fields) => {

    }
  )
};
